export default "__VITE_ASSET__BtoKRCqF__"